var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"overlay"},[_c('HeadCont',{attrs:{"msg":"Welcome To Your Home Page"}}),_c('Forms')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }